import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { formatter } from "@/shared/ts/formatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeGuidanceSummary',
  props: {
    suggestedAmountOnPlsaDate: { type: Number, default: 0 },
    suggestedAmountAtRetirement: { type: Number, default: 0 },
    incomeSetupMode: { type: Boolean, required: true }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.incomeSetupMode)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _cache[0] || (_cache[0] = _createTextVNode(" Based on your answers, the ")),
        _cache[1] || (_cache[1] = _createElementVNode("a", {
          href: "https://www.retirementlivingstandards.org.uk",
          target: "_blank",
          title: "Pensions and Lifetime Savings Association (PLSA)"
        }, "Pensions and Lifetime Savings Association (PLSA)", -1)),
        _createTextVNode(" suggest an after tax income if you retired in 2023 of " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountOnPlsaDate)) + ". We have increased that by 2.5% per year to when you want to retire in the box below. You can change this in the box below if want to target more or less than the answer given. ", 1)
      ]))
    : (_openBlock(), _createElementBlock("p", _hoisted_2, [
        _cache[2] || (_cache[2] = _createTextVNode(" Based on your answers, the ")),
        _cache[3] || (_cache[3] = _createElementVNode("a", {
          href: "https://www.retirementlivingstandards.org.uk",
          target: "_blank",
          title: "Pensions and Lifetime Savings Association (PLSA)"
        }, "Pensions and Lifetime Savings Association (PLSA)", -1)),
        _createTextVNode(" suggest an after tax income if you retired in 2023 of " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountOnPlsaDate)) + ". Increasing that by 2.5% per year to when you want to retire is " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountAtRetirement)), 1)
      ]))
}
}

})